module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Ad_N"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "LOVE"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pz16-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ba_03",
      "id": "ab_03"
    }
  }, [_c('b', [_vm._v("LOVE")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-3"
    }
  }, [_vm._v("But God demonstrates His own love toward us, in that while we were still sinners, Christ died for us.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz16-4"
    }
  }, [_c('em', [_vm._v("Romans 5:8")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-5"
    }
  }, [_vm._v("For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz16-6"
    }
  }, [_c('em', [_vm._v("John 3:16")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-7"
    }
  }, [_vm._v("Beloved, let us love one another, for love is of God; and everyone who loves is born of God and knows God.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-8"
    }
  }, [_vm._v("He who does not love does not know God, for God is love.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-9"
    }
  }, [_vm._v("In this the love of God was manifested toward us, that God has sent His only begotten Son into the world, that we might live through Him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-10"
    }
  }, [_vm._v("In this is love, not that we loved God, but that He loved us and sent His Son to be the propitiation for our sins.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-11"
    }
  }, [_vm._v("Beloved, if God so loved us, we also ought to love one another.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-12"
    }
  }, [_vm._v("No one has seen God at any time. If we love "), _c('span', {
    attrs: {
      "id": "z17-1"
    }
  }, [_vm._v("one another, God abides in us, and His love has been perfected in us. ")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz17-2"
    }
  }, [_c('em', [_vm._v("1 John 4:7–12")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-3"
    }
  }, [_vm._v("And we have known and believed the love that God has for us. God is love, and he who abides in love abides in God, and God in him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-4"
    }
  }, [_vm._v("We love Him because He first loved us.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz17-5"
    }
  }, [_c('em', [_vm._v("1 John 4:16, 19")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-6"
    }
  }, [_vm._v("As the Father loved Me, I also have loved you; abide in My love.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-7"
    }
  }, [_vm._v("If you keep My commandments, you will abide in My love, just as I have kept My Father’s commandments and abide in his love.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-8"
    }
  }, [_vm._v("These things I have spoken to you, that My joy may remain in you, and that your joy may be full.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-9"
    }
  }, [_vm._v("This is My commandment, that you love one another as I have loved you.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-10"
    }
  }, [_vm._v("Greater love has no one than this, than to lay down one’s life for his friends.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-11"
    }
  }, [_vm._v("These things I command you, that you love one another.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz17-12"
    }
  }, [_c('em', [_vm._v("John 15:9–13, 17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-1"
    }
  }, [_vm._v("That Christ may dwell in your hearts through faith; that you, being rooted and grounded in love,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "An5"
    }
  }, [_vm._v("may be able to comprehend with all the saints what is the width and length and depth and height—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-2"
    }
  }, [_vm._v("to know the love of Christ which passes knowledge; that you may be filled with all the fullness of God.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz18-3"
    }
  }, [_c('em', [_vm._v("Ephesians 3:17–19")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-4"
    }
  }, [_vm._v("I love those who love me, and those who seek me diligently will find me.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz18-5"
    }
  }, [_c('em', [_vm._v("Proverbs 8:17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" has appeared of old to me, saying:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-7"
    }
  }, [_vm._v("“Yes, I have loved you with an everlasting love;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-8"
    }
  }, [_vm._v("Therefore with lovingkindness I have drawn you.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz18-10"
    }
  }, [_c('em', [_vm._v("Jeremiah 31:3")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-11"
    }
  }, [_vm._v("I will betroth you to Me forever;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-12"
    }
  }, [_vm._v("Yes, I will betroth you to Me in righteousness and justice,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-13"
    }
  }, [_vm._v("In lovingkindness and mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz18-14"
    }
  }, [_c('em', [_vm._v("Hosea 2:19")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-1"
    }
  }, [_vm._v("He who has My commandments and keeps them, it is he who loves Me. And he who loves Me will be loved by My Father, and I will love him and manifest Myself to him.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz19-2"
    }
  }, [_c('em', [_vm._v("John 14:21")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-3"
    }
  }, [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will command his lovingkindness in the daytime,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-4"
    }
  }, [_vm._v("And in the night His song shall be with me—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-5"
    }
  }, [_vm._v("A prayer to the God of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz19-6"
    }
  }, [_c('em', [_vm._v("Psalm 42:8")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-7"
    }
  }, [_vm._v("And now abide faith, hope, love, these three; but the greatest of these is love.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz19-8"
    }
  }, [_c('em', [_vm._v("I Corinthians 13:13")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-9"
    }
  }, [_vm._v("For I am persuaded that neither death nor life, nor angels nor principalities nor powers, nor things present nor things to come,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-10"
    }
  }, [_vm._v("nor height nor depth, nor any other created thing, shall be able to separate us from the love of God which is in Christ Jesus our Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz19-13"
    }
  }, [_c('em', [_vm._v("Romans 8:38, 39")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7e4146e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 81
// module chunks = 0